<template>
  <div class="bg-5">
    <div class="container-xxl" :class="{ 'd-lg-flex': aside }">
      <aside v-if="aside" class="pt-8 pr-lg-5">
        <slot name="aside" />
      </aside>
      <section class="py-8" :class="{ 'pl-lg-6 flex-fill': aside }">
        <slot />
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    aside: Boolean
  }
};
</script>
